<template>
<div class="features">
	<!-- Warning -->
	<div class="" :class="{'is-visible': !hasThree, 'is-hidden': hasThree}">
		<span class="message--error">Add at least 3 features for portal upload!</span>
	</div>

	<!-- Features -->
	<div class="width-100 mdc-textfield mdc-textfield--upgraded" v-for="(feature, index) in features">
		<input class="mdc-textfield__input input--centered" :class="{'input--focus' : value !== ''}" type="text" :value="feature" @input="update(index, $event)" v-focus>
		<a href="#" class="input__closebtn" @click.prevent="clear(index)"><i class="ico-delete"></i></a>
	</div>

	<!-- Add more button -->
	<div class="editable-features__add-more">
		<div class="btn btn--bordered" @click.prevent='add'>
			<i class="ico-plus_math"></i> Add feature
		</div>
	</div>

</div>
</template>

<script>
export default {
	props: ['value'],
	data: function() {
		return {
			features: this.value ? this.value : [],
			hasThree: true
		}
	},
	methods: {
		add: function() {
    console.log('this.features',this.features);
    this.checkHasThree();
			//if (this.checkHasThree()) {
				this.features.push('');
				this.$emit('input', this.features);
			//} else {
				// animate empty input
			//}
			this.checkHasThree();
		},
		remove: function(index) {
			this.features.splice(index, 1);
			this.$emit('input', this.features);
			this.checkHasThree();
		},
		clear: function(index) {
			this.features.splice(index, 1, '');
			this.$emit('input', this.features);
			this.checkHasThree();
		},
		update: function(index, e) {
			this.features[index] = e.target.value;
			this.$emit('input', this.features);
			this.checkHasThree();
		},
		checkHasThree: function() {
			var notEmptyFeatures = 0

			// count how many not empty features are
			this.features.forEach(function(feature) {
				if (feature !== '') {
					notEmptyFeatures ++
				}
			})
			this.hasThree = notEmptyFeatures >= 3
			this.$emit('hasThree', this.hasThree)
			return this.hasThree
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/EditableFeatures.vue